// react-magnetic-di - temporary comment, for auto dependency injection in tests
import React from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';
import { parseExtensionId } from '@atlassian/forge-ui/utils/parseExtensionId';

import { useTriggerFieldInitialization } from '../../../../controllers/issue-adjustments/hooks/use-trigger-field-initialization';

import { SingleAppRenderer } from './single-app-renderer';
import { type ForgeAppRendererComponent } from './single-app-renderer/types';
import { type AppToRenderResult } from './use-apps-to-render/types';

export interface AppsRendererProps {
	apps: AppToRenderResult[];
	ForgeAppRenderer: ForgeAppRendererComponent;
}

export const AppsRenderer = ({ ForgeAppRenderer, apps }: AppsRendererProps) => {
	const [triggerFieldInitializationKey] = useTriggerFieldInitialization();

	return (
		<>
			{apps.map(({ forgeExtension, uiModificationsConfig }) => {
				const { appId, environmentId: envId } = parseExtensionId(forgeExtension.id);

				return (
					<AnalyticsContext
						key={`${forgeExtension.id}-${triggerFieldInitializationKey}`}
						data={{ attributes: { appId, envId } }}
					>
						<SingleAppRenderer
							forgeExtension={forgeExtension}
							uiModificationsConfig={uiModificationsConfig}
							ForgeAppRenderer={ForgeAppRenderer}
						/>
					</AnalyticsContext>
				);
			})}
		</>
	);
};
